// arrive_info/ArriveInfoGql.js
import { gql } from "@apollo/client";

/* ************************************************
 * ARRIVE_INFO Apollo Graphql
 * Project: NewTOP for cloud
 * 2024-08-28 13:39:59 using DbdbTap
 ************************************************ */

const ARRIVE_INFO_LIST_PART = gql`
fragment ArriveInfoListPart on ArriveInfo {
    arriveId
    dcCd
    storeId
    basicDockno
    distanceOne
    distanceRound
    basicExpectRunTime
    startReqTimeToday
    arriveReqTimeNext
    useYn
    regTypeCd
    regType
    firstShipTime
    lastShipTime
    autoPlanYn
    autoPlanOrder
    autoViewOrder
    mainVehTypeId
	mainVehTypeName
    maxVehTypeName
    maxVehTypeId
    storeApplyCom
    pbsOrder
    loadMaxCnt
    regDate
    regUser
    regUserName
    dcTypeCd
    dcTypeName
    dcName
    storeTypeName
    storeTypeCd
    storeName
    addr
    useStoreYn
    comName
}
`;

export const LIST_ARRIVE_INFO = gql`
${ARRIVE_INFO_LIST_PART}
query ListArriveInfo($dcCd:String) {
    arriveInfoList(dcCd:$dcCd) {
        ...ArriveInfoListPart
    }
}
`;

export const LIST_ARRIVE_INFO_TO_SELECT_STORE = gql`
query ListArriveInfo($dcCd:String) {
    arriveInfoList(dcCd:$dcCd) {
        arriveId
        dcCd
        storeId
        dcTypeCd
        dcTypeName
        dcName
        storeTypeName
        storeTypeCd
        storeName
        basicDockno
        useYn
        autoPlanYn
    }
}
`;

// arriveInfoListForRouteSharing: [ArriveInfo]!
// 동적점포 후보 점포목록 조회. (편집시에는 사용중인 점포들을 제외하고 표시해야 함)
export const LIST_ARRIVE_INFO_FOR_ROUTE_SHARING = gql`
query ListArriveInfoForRouteSharing {
    arriveInfoListForRouteSharing {
        storeId
        storeName
        addr
        maxVehTypeName
        firstShipTime
    }
}
`;

// arriveInfoStoreListForDida(dcCd:String!): [ArriveInfo]!
// 점포 휴무일 등록시 사용할 점포목록 조회
export const LIST_ARRIVE_INFO_STORE_LIST_FOR_DIDA = gql`
query ListArriveInfoStoreListForDida($dcCd:String!) {
    arriveInfoStoreListForDida(dcCd:$dcCd) {
        dcCd
        dcName
        storeId
        storeName
        addr
    }
}
`;

export const GET_ARRIVE_INFO = gql`
${ARRIVE_INFO_LIST_PART}
query GetArriveInfo($arriveId:String!) {
    arriveInfoItem(arriveId:$arriveId) {
        ...ArriveInfoListPart
    }
}
`;

export const ADD_ARRIVE_INFO = gql`
mutation AddArriveInfo($arriveInfo:InputArriveInfoAdd!) {
	arriveInfoAdd(arriveInfo: $arriveInfo) {
		ok
		message
	}
}
`;

export const EDIT_ARRIVE_INFO = gql`
mutation EditArriveInfo($arriveInfo:InputArriveInfoEdit!) {
	arriveInfoEdit(arriveInfo: $arriveInfo) {
		ok
		message
	}
}
`;

export const REMOVE_ARRIVE_INFO = gql`
mutation RemoveArriveInfo($arriveInfo:InputArriveInfoRemove!) {
	arriveInfoRemove(arriveInfo: $arriveInfo) {
		ok
		message
	}
}
`;

export const SET_USAGE_ARRIVE_INFO = gql`
mutation SetUsageArriveInfo($arriveInfo:InputArriveInfoSetUsage!) {
	arriveInfoSetUsage(arriveInfo: $arriveInfo) {
		ok
		message
	}
}
`;

/*


input InputArriveInfoSetAutoPlanOrder {
    arriveId: String!
    autoPlanOrder: Int!
}

input InputArriveInfoUnsetAutoPlanOrder {
    arriveId: String!
}


    arriveInfoSetAutoPlanOrder(arriveInfo: InputArriveInfoSetAutoPlanOrder!): CommonResponse
    arriveInfoUnsetAutoPlanOrder(arriveInfo: InputArriveInfoUnsetAutoPlanOrder!): CommonResponse
*/

export const SET_AUTO_PLAN_ORDER_ARRIVE_INFO = gql`
mutation SetAutoPlanOrderArriveInfo($arriveInfo:InputArriveInfoSetAutoPlanOrder!) {
    arriveInfoSetAutoPlanOrder(arriveInfo: $arriveInfo) {
        ok
        message
    }
}
`;

export const UNSET_AUTO_PLAN_ORDER_ARRIVE_INFO = gql`
mutation UnsetAutoPlanOrderArriveInfo($arriveInfo:InputArriveInfoUnsetAutoPlanOrder!) {
    arriveInfoUnsetAutoPlanOrder(arriveInfo: $arriveInfo) {
        ok
        message
    }
}
`;

/*
input InputArriveInfoSetAutoViewOrder {
    arriveId: String!
    targetId: String
}


    arriveInfoSetAutoViewOrder(arriveInfo: InputArriveInfoSetAutoViewOrder!): CommonResponse
*/

export const SET_AUTO_VIEW_ORDER_ARRIVE_INFO = gql`
mutation SetAutoViewOrderArriveInfo($arriveInfo:InputArriveInfoSetAutoViewOrder!) {
    arriveInfoSetAutoViewOrder(arriveInfo: $arriveInfo) {
        ok
        message
    }
}
`;

/*

# Batch upload response list's own item
type ArriveInfoResponse {
	ok: Boolean!
	message: String
    arriveId: String!
}

type ResponseWithArriveInfoResList {
    ok: Boolean!
    message: String
    list: [ArriveInfoResponse]!
}

    arriveInfoUpload(arriveInfoList: [InputArriveInfoAdd]!): ResponseWithArriveInfoResList
*/

export const UPLOAD_ARRIVE_INFO = gql`
mutation UploadArriveInfo($arriveInfoList:[InputArriveInfoAdd]!) {
    arriveInfoUpload(arriveInfoList: $arriveInfoList) {
        ok
        message
        list {
            ok
            message
            arriveId
        }
    }
}
`;

